// Must be first. `container.load()` below reaches `Reflect.getMetadata`, which only
// exists after this polyfill has run.
//
// main.ts already imports 'reflect-metadata' as its first import, but that is not
// sufficient for the production build: Vite/rolldown code-splits this module into a
// shared chunk, and ES modules evaluate every statically imported chunk *before* the
// importing (entry) chunk's own body. The polyfill is inlined into the entry chunk, so
// it would run after this module. Importing it here makes it a direct dependency of the
// module that needs it, which guarantees the correct order regardless of chunking.
import 'reflect-metadata';

import { Container } from 'inversify';

import { buildMetadataModule, METADATA_KEY } from '@/decorators/metadata';

export const container = new Container({
  autoBindInjectable: true,
  defaultScope: 'Singleton',
  skipBaseClassChecks: true,
});

container.load(buildMetadataModule(METADATA_KEY.FACTORY));
